import { t } from 'i18next';
import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';

import { deepestRouteTitleKey } from '~router/routeHandle';
import formatUnreadCount from '~utils/formatUnreadCount';

export default function useDocumentTitle(unreadTotal = 0) {
  const titleKey = deepestRouteTitleKey(useMatches());

  useEffect(() => {
    const pageTitle = titleKey
      ? t('document_title.with_page', { pageName: t(titleKey) })
      : t('document_title.without_page');
    const unreadPrefix = unreadTotal > 0 ? `(${formatUnreadCount(unreadTotal)}) ` : '';

    document.title = `${unreadPrefix}${pageTitle}`;
  }, [titleKey, unreadTotal]);
}
